export default __webpack_public_path__ + "assets/ico_step_3-9bc8a8d1.svg";